import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class GranularNowProvider {

  private cachedNow: string | null = null;
  private lastUpdate: number = 0;

  private readonly GRANULARITY = 10 * 60 * 1000; // 10 minutes

  getNow(): string {

    const now = Date.now();

    if (!this.cachedNow || (now - this.lastUpdate) > this.GRANULARITY) {

      this.cachedNow = new Date(now).toISOString();

      this.lastUpdate = now;
    }

    return this.cachedNow;
  }

}
